import { Reveal, Overline } from "./Reveal";

export const Commitment = () => (
  <section className="relative bg-[#1a1410] py-24 sm:py-36">
    <div className="mx-auto max-w-[1000px] px-5 sm:px-8 text-center">
      <Reveal>
        <div className="flex justify-center">
          <Overline>Our Commitment</Overline>
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <p className="mt-8 font-serif text-2xl sm:text-4xl lg:text-[2.75rem] leading-[1.25] text-zinc-100">
          We don't simply offer services — we build long-term relationships
          centered on{" "}
          <span className="text-gold-foil">trust, professionalism,</span> and
          measurable results.
        </p>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mt-10 font-serif italic text-2xl text-amber-400">
          Your success is our success.
        </p>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mt-6 text-zinc-400 font-light max-w-2xl mx-auto leading-relaxed">
          Our goal is to help every client recover opportunities, strengthen
          financial stability, and build a legacy that lasts for generations.
        </p>
      </Reveal>
    </div>
  </section>
);
